import {
  type GLTF,
  GLTFLoader
} from "three/examples/jsm/loaders/GLTFLoader.js";

import { LoadableResource } from "./LoadableResource";

export class LoadableGLTFResource<
  TL extends string = string,
  TT extends string = string
> extends LoadableResource<GLTF> {
  // Potential kludge here. I don't care.
  static gltfLoader = new GLTFLoader();
  private resourceUrl: string;

  constructor(prsUrl: string) {
    super();
    this.resourceUrl = prsUrl;
  }

  async getResourcePromise(): Promise<GLTF> {
    await this.load();
    return this.getResource();
  }
  async load(): Promise<void> {
    await super.internalResourceLoadSequenceFromFunction(() => {
      return LoadableGLTFResource.gltfLoader.loadAsync(this.resourceUrl);
    });
  }
}
